module.exports = __webpack_public_path__ + "img/logo.259a00e8.svg";